import Header from "../Header/Header";
import ProspectPropertyService from "../Service/ProspectPropertyService";
import CustomHeading from "../../components/common/CustomHeading";

import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { CiMenuKebab } from "react-icons/ci";
import CustomModel from "../../components/common/CustomModel";
import CustomSelect from "../../components/common/CustomSelect";

import {
  showErrorToast,
  showSuccessToast,
} from "../../components/Constant/Notification";
import { userUid } from "../../utils/storage";
import { Divider, MenuItem } from "../../components/Constant/Constant";
import {
  FiXCircle,
  FiAlertCircle,
  FiEdit,
  FiCheckCircle,
} from "react-icons/fi";
import {
  getPriorityBadgeColor,
  periotyQueryEnum,
  queryCategories,
} from "../Enum/QueryEnum";
import UserService from "../../GlobalSetupComponents/Services/UserService";
import {
  formatDate,
  formatDateForInput,
  formatToIndianDate,
} from "../../utils/dateFormatter";
import CustomSidebar from "../../components/common/CustomSidebar";
import AdvocateService from "../Service/AdvocateService";
import MediaUpload from "../../components/SetupComponents/PropertiesComponents/MediaUpload";
import { queryUserList } from "../../GlobalSetupComponents/Enum/RoleEnum";
import CustomAdvocateList from "../PropertyProcurementSection/PropertyInfoSection/PropertyQueries/CustomAdvocateList";
import QueriesInfoPage from "../PropertyProcurementSection/PropertyInfoSection/PropertyQueries/QueriesInfoPage";
import { SearchIcon } from "lucide-react";
import { ToastContainer } from "react-toastify";

const ProcurementQueryPage = () => {
  // Stage data for Kanban columns
  const [stageData, setStageData] = useState({
    "PENDING": { data: [], count: 0, next: "", loading: false, hasMore: true },
    "RESOLVED": { data: [], count: 0, next: "", loading: false, hasMore: true },
    "IGNORED": { data: [], count: 0, next: "", loading: false, hasMore: true },
  });
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isResolveModalOpen, setIsResolveModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [actionType, setActionType] = useState(null); // 'resolve', 'ignore', 'drop'
  const [resolveComment, setResolveComment] = useState("");
  const [editFormData, setEditFormData] = useState({
    title: "",
    description: "",
    category: null,
    givenBy: null,
    targetDate: "",
    priority: null,
    associatedLegalOpinion: null,
    files: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [users, setUsers] = useState([]);
  const [advocateOpinions, setAdvocateOpinions] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    pending: 0,
    resolved: 0,
    ignored: 0,
    total: 0,
  });
  const [isQueryInfoOpen, setIsQueryInfoOpen] = useState(false);
  
  // Sidebar stack management
  const [sidebarStack, setSidebarStack] = useState([]);
  const [activeSidebar, setActiveSidebar] = useState(null);
  
  const dropdownRef = useRef(null);
  const observerRefs = useRef({});
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
    const [queryLoading, setQueryLoading] = useState(false);

  const fetchQuertyPropertyList = async () => {
    try {
      const response = await ProspectPropertyService.getOverAllQueryPropertyList();
      setProperties(response.data?.properties || []);
        setFilteredProperties(response.data?.properties || []);
     
     
        const data = response.data?.properties;

        setSelectedPropertyId(data[0].id);
      
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  useEffect(() => {
    fetchQuertyPropertyList();
  }, []);

  const handlePropertySelection = (id) => {
    setSelectedPropertyId(id);
    // Reset all stage data when switching properties
    setStageData({
      "PENDING": { data: [], count: 0, next: "", loading: false, hasMore: true },
      "RESOLVED": { data: [], count: 0, next: "", loading: false, hasMore: true },
      "IGNORED": { data: [], count: 0, next: "", loading: false, hasMore: true },
    });
  };

  const handleScroll = useCallback(
    (e, stageValue) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - scrollTop <= clientHeight + 100) {
        const stage = stageData[stageValue];
        if (stage.hasMore && !stage.loading && stage.next) {
          fetchQueries(stageValue, stage.next, true);
        }
      }
    },
    [stageData, selectedPropertyId]
  );

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "",
    givenBy: "",
    givenByName: "",
    targetDate: "",
    priority: "MINOR",
    associatedLegalOpinion: "",
    files: [],
  });

  // Sidebar management functions
  const openSidebar = (sidebarType, data = {}) => {
    // Close current active sidebar if any
    if (activeSidebar) {
      setSidebarStack([...sidebarStack, activeSidebar]);
    }
    
    // Set new active sidebar
    setActiveSidebar({ type: sidebarType, data });
    
    // Open the appropriate sidebar
    switch (sidebarType) {
      case 'addQuery':
        setIsModalOpen(true);
        break;
      case 'editQuery':
        setIsEditModalOpen(true);
        break;
      case 'resolveQuery':
        setIsResolveModalOpen(true);
        break;
      case 'queryInfo':
        setIsQueryInfoOpen(true);
        break;
      default:
        console.warn(`Unknown sidebar type: ${sidebarType}`);
    }
  };

  const closeSidebar = (sidebarType) => {
    // Close the specified sidebar
    switch (sidebarType) {
      case 'addQuery':
        setIsModalOpen(false);
        break;
      case 'editQuery':
        setIsEditModalOpen(false);
        break;
      case 'resolveQuery':
        setIsResolveModalOpen(false);
        break;
      case 'queryInfo':
        setIsQueryInfoOpen(false);
        break;
      default:
        console.warn(`Unknown sidebar type: ${sidebarType}`);
    }

    // Check if there's a previous sidebar in the stack
    if (sidebarStack.length > 0) {
      const previousSidebar = sidebarStack[sidebarStack.length - 1];
      setSidebarStack(sidebarStack.slice(0, -1));
      setActiveSidebar(previousSidebar);
      
      // Open the previous sidebar
      switch (previousSidebar.type) {
        case 'addQuery':
          setIsModalOpen(true);
          break;
        case 'editQuery':
          setIsEditModalOpen(true);
          break;
        case 'resolveQuery':
          setIsResolveModalOpen(true);
          break;
        case 'queryInfo':
          setIsQueryInfoOpen(true);
          break;
      }
    } else {
      setActiveSidebar(null);
    }
  };

  const closeAllSidebars = () => {
    setIsModalOpen(false);
    setIsEditModalOpen(false);
    setIsQueryInfoOpen(false);
    setIsResolveModalOpen(false);
    setActiveSidebar(null);
    setSidebarStack([]);
  };

  const fetchAdvocateOpinion = async () => {
    if (!selectedPropertyId) return; // Don't fetch if no property is selected
    
    try {
      const response = await AdvocateService.getAdvocateOpinionPropertyId(selectedPropertyId);
      setAdvocateOpinions(response.data?.advocateOpinionData || []);
    } catch (error) {
      console.error("Error fetching advocate opinions:", error);
      setAdvocateOpinions([]); 
    }
  };

  useEffect(() => {
    fetchAdvocateOpinion();
  }, [selectedPropertyId]);

  const fetchRoleBasedUsers = async () => {
    try {
        const body = { roleIds: queryUserList };
      const response = await UserService.getUserRoleBasedNames(body);
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
      showErrorToast("Failed to fetch users.");
    }
  };

  const fetchQueries = async (stageValue, startAfter = null, isLoadMore = false) => {
    if (!selectedPropertyId) return;
    
    try {
      setStageData((prev) => ({
        ...prev,
        [stageValue]: { ...prev[stageValue], loading: true },
      }));

      const response = await ProspectPropertyService.getPropertyQueries({
        propertyId: selectedPropertyId,
        status: stageValue,
        limit: 10,
        startAfter,
      });

      const newQueries = response.data.queries || [];
      const statusCounts = response.data.statusCounts || {};
      
      setStageData((prev) => ({
        ...prev,
        [stageValue]: {
          data: isLoadMore ? [...prev[stageValue].data, ...newQueries] : newQueries,
          count: statusCounts[stageValue.toLowerCase()] || 0,
          next: response.data.pagination?.lastDocId || "",
          loading: false,
          hasMore: response.data.pagination?.hasMore || false,
        },
      }));

      // Update overall status counts only once when fetching all stages
      setStatusCounts({
        ...statusCounts,
        total: response.data.pagination?.total || 0,
      });
    } catch (error) {
      console.error(`Error fetching ${stageValue} queries:`, error);
      setStageData((prev) => ({
        ...prev,
        [stageValue]: { ...prev[stageValue], loading: false },
      }));
      showErrorToast(`Failed to fetch ${stageValue.toLowerCase()} queries.`);
    }
  };

  const loadAllStages = async () => {
    if (!selectedPropertyId) return;
    const stages = ["PENDING", "RESOLVED", "IGNORED"];
    const promises = stages.map((stage) => fetchQueries(stage));
    await Promise.all(promises);
  };

  const handleAddQuery = async () => {
    if (
      !formData.title ||
      !formData.description ||
      !formData.priority ||
      !formData.category ||
      !formData.givenBy ||
      !formData.targetDate ||
      (formData.category === "Advocate Analysis" && !formData.associatedLegalOpinion)
    ) {
      showErrorToast("Please fill all required fields.");
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const queryData = {
        title: formData.title,
        description: formData.description,
        priority: formData.priority,
        category: formData.category,
        givenBy: formData.givenBy,
        targetDate: formatDate(formData.targetDate),
        associatedLegalOpinion: formData.associatedLegalOpinion || null,
        fileUrl: formData.files.length > 0 ? formData.files[0] : null,
        createdBy: userUid,
        prospectPropertyId: selectedPropertyId,
      };

      const response = await ProspectPropertyService.createPropertyQuery(queryData);
      if (response.status === 200 || response.status === 201) {
        showSuccessToast(response.data.message);
        closeSidebar('addQuery');
        loadAllStages();
      }
      setFormData({
        title: "",
        description: "",
        category: "",
        givenBy: "",
        givenByName: "",
        targetDate: "",
        priority: "MINOR",
        associatedLegalOpinion: "",
        files: [],
      });
    } catch (error) {
      console.error("Error adding query:", error);
      showErrorToast("Failed to add query.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, selected) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selected?.value || "",
      ...(name === "givenBy" ? { givenByName: selected?.label || "" } : {}),
    }));
  };

  const handleMenuClick = (query, action, infoOpen = true) => {
    setActiveDropdown(null);
    setSelectedQuery(query);
    setActionType(action);

    switch (action) {
      case "resolve":
        openSidebar('resolveQuery');
        break;
      case "ignore":
        openSidebar('resolveQuery');
        break;
      case "edit":
        if (query) {
                  const selectedUser = (users || []).find((u) => u.value === query.givenBy?.id);
                  const selectedPriority = (periotyQueryEnum || []).find((p) => p.value === query.priority);
                  const selectedCategory = (queryCategories || []).find((c) => c.value === query.category);
                  const selectedOpinion = (advocateOpinions || []).find((o) => o.id === query.associatedLegalOpinion?.id);
        
                  setEditFormData({
                    title: query.title || "",
                    description: query.description || "",
                    priority: selectedPriority
                      ? { value: selectedPriority.value, label: selectedPriority.label }
                      : null,
                    category: selectedCategory
                      ? { value: selectedCategory.value, label: selectedCategory.label }
                      : null,
                    givenBy: selectedUser
                      ? { value: selectedUser.value, label: selectedUser.label }
                      : null,
                    targetDate: formatDateForInput(query.targetDate) || "",
                    associatedLegalOpinion: selectedOpinion
                      ? {
                          value: selectedOpinion.id,
                          label: `${(advocateOpinions || []).findIndex((o) => o.id === selectedOpinion.id) + 1}. ${selectedOpinion.type}`,
                        }
                      : null,
                    files: query.fileUrl ? [query.fileUrl] : [],
                  });
                 
                }
        openSidebar('editQuery');
        break;
      case "drop":
        openSidebar('resolveQuery');
        break;
      default:
        console.warn(`Unknown action: ${action}`);
    }
  };

  const handleConfirmAction = async () => {
    if (!selectedQuery) return;
    let response;
    setQueryLoading(true);
    try {
      switch (actionType) {
        case "resolve":
          if(!resolveComment.trim()){
            showErrorToast("Please enter a comment");
            return;
          }
          response = await ProspectPropertyService.updatePropertyQueryStatus({
            queryId: selectedQuery.id,
            status: "RESOLVED",
            reason: resolveComment,
            modifiedBy: userUid,
          });
          if (response.status === 200 || response.status === 201) {
            showSuccessToast(response.data.message);
            closeSidebar('resolveQuery');
          }
          break;
        case "ignore":
          if(!resolveComment.trim()){
            showErrorToast("Please enter a comment");
            return;
          }
          response = await ProspectPropertyService.updatePropertyQueryStatus({
            queryId: selectedQuery.id,
            status: "IGNORED",
            reason: resolveComment,
            modifiedBy: userUid,
          });
          if (response.status === 200 || response.status === 201) {
            showSuccessToast(response.data.message);
            closeSidebar('resolveQuery');
          }
          break;
        case "drop":
          if(!resolveComment.trim()){
            showErrorToast("Please enter a comment");
            return;
          }
          response = await ProspectPropertyService.updatePropertyQueryStatus({
            queryId: selectedQuery.id,
            status: "DROPPED",
            reason: resolveComment,
            modifiedBy: userUid,
          });
          if (response.status === 200 || response.status === 201) {
            showSuccessToast(response.data.message);
            closeSidebar('resolveQuery');
          }
          break;
      }
      
      setResolveComment("");
      setSelectedQuery(null);
      setActionType(null);
      loadAllStages();
    } catch (error) {
      console.error(`Error performing ${actionType} on query:`, error);
      showErrorToast(`Failed to ${actionType} query.`);
    }finally{
      setQueryLoading(false);
    }
  };

  const handleUpdateQuery = async () => {
    if (!selectedQuery) return;

    // if (
    //   !editFormData.title ||
    //   !editFormData.description ||
    //   !editFormData.priority?.value ||
    //   !editFormData.category?.value ||
    //   !editFormData.givenBy?.value ||
    //   !editFormData.targetDate ||
    //   (editFormData.category?.value === "Advocate Analysis" && !editFormData.associatedLegalOpinion?.value)
    // ) {
    //   showErrorToast("Please fill all required fields.");
    //   return;
    // }

    if(!editFormData.category){ 
      showErrorToast("Please select a category");
      return;
    }
    if(editFormData.category?.value === "Advocate Analysis" && !editFormData.associatedLegalOpinion?.value){
      showErrorToast("Please select associated legal opinion");
      return;
    }
    
    if(!editFormData.title.trim()){ 
      showErrorToast("Title cannot be empty");
      return;
    }
    if(!editFormData.description.trim()){
      showErrorToast("Description cannot be empty");
      return;
    }
    if(!editFormData.targetDate){
      showErrorToast("Please select a target date");
      return;
    }
    if(!editFormData.givenBy){ 
      showErrorToast("Please select who given the query");
      return;
    }
    if(!editFormData.priority){ 
      showErrorToast("Please select a priority");
      return;
    }
    

  

    setLoading(true);
    try {
      const updateData = {
        queryId: selectedQuery.id,
        title: editFormData.title,
        description: editFormData.description,
        priority: editFormData.priority.value,
        category: editFormData.category.value,
        givenBy: editFormData.givenBy.value,
        targetDate: formatDate(editFormData.targetDate),
        associatedLegalOpinion: editFormData.associatedLegalOpinion?.value || null,
        fileUrl: editFormData.files.length > 0 ? editFormData.files[0] : null,
        modifiedBy: userUid,
      };

      const response = await ProspectPropertyService.updatePropertyQuery(updateData);
      if (response.status === 200 || response.status === 201) {
        showSuccessToast(response.data.message);
        closeSidebar('editQuery');
      }

      setEditFormData({
        title: "",
        description: "",
        category: null,
        givenBy: null,
        targetDate: "",
        priority: null,
        associatedLegalOpinion: null,
        files: [],
      });
      loadAllStages();
    } catch (error) {
      console.error("Error updating query:", error);
      showErrorToast("Failed to update query.");
    } finally {
      setLoading(false);
    }
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSelectChange = (name, selected) => {
    setEditFormData((prev) => ({
      ...prev,
      [name]: selected || null,
    }));
  };

  const getActionTitle = () => {
    switch (actionType) {
      case "resolve":
        return "Resolve Query";
      case "ignore":
        return "Ignore Query";
      case "drop":
        return "Drop Property";
      default:
        return "Action";
    }
  };

  const getActionButtonText = () => {
    switch (actionType) {
      case "resolve":
        return "Resolve";
      case "ignore":
        return "Ignore";
      case "drop":
        return "Drop";
      default:
        return "Action";
    }
  };

  const getActionButtonColor = () => {
    switch (actionType) {
      case "resolve":
        return "bg-green-600 hover:bg-green-700";
      case "ignore":
        return "bg-yellow-600 hover:bg-yellow-700";
      case "drop":
        return "bg-red-600 hover:bg-red-700";
      default:
        return "bg-gray-600 hover:bg-gray-700";
    }
  };

  const toggleDropdown = (queryId) => {
    setActiveDropdown(activeDropdown === queryId ? null : queryId);
  };

  // Remove the intersection observer useEffect as we'll use scroll handling instead

  useEffect(() => {
    fetchRoleBasedUsers();
  }, []);

  useEffect(() => {
    if (selectedPropertyId) {
      loadAllStages();
    }
  }, [selectedPropertyId]);

  // Cleanup sidebars when component unmounts or selectedPropertyId changes
  useEffect(() => {
    return () => {
      closeAllSidebars();
    };
  }, [selectedPropertyId]);

    const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    const filtered = properties.filter((property) =>
      property.propertyName.toLowerCase().includes(query)
    );
    setFilteredProperties(filtered);
  }

  const renderPropertySelectionColumn = () => {
    return (
      <div className="flex flex-col gap-4">
        <div className="text-[18px] font-medium">Select Property</div>
        <div className="bg-white relative h-[calc(100vh-270px)] overflow-y-auto w-[370px] rounded-[10px] shadow">
            <div className=" rounded-lg mx-3 mt-3 top-0 sticky">
                <input
                  type="text"
                  placeholder="Search Property"
                  className="w-full p-3 border-b border-gray-200 input-focus rounded-md "
                   onChange={handleSearchChange}
                />
                <SearchIcon className="absolute right-4 top-3 text-gray-400" />
            </div>
          {filteredProperties.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                if (item.id !== selectedPropertyId) {
                  handlePropertySelection(item.id);
                }
              }}
              className={`p-3 rounded-lg m-3 flex items-center justify-between mb-4 cursor-pointer transition-all duration-200 ${
                selectedPropertyId === item.id
                  ? "bg-blue-50 border-2 border-blue-200 shadow-sm"
                  : "bg-gray-50 border border-gray-200 hover:bg-gray-100"
              }`}
            >
              <div className="text-base font-medium cursor-pointer truncate w-40">
                {item.propertyName}
              </div>
              <div className="flex items-center gap-2">
                <div className="flex items-center rounded-full bg-blue-50 border border-blue-200 h-8 w-8 text-center justify-center text-blue-600 text-sm font-medium">
                  {item.queryStatusCounts?.pending || 0}
                </div>
                <div className="flex items-center rounded-full bg-green-50 border border-green-200 h-8 w-8 text-center justify-center text-green-600 text-sm font-medium">
                  {item.queryStatusCounts?.resolved || 0}
                </div>
                <div className="flex items-center rounded-full bg-orange-50 border border-orange-200 h-8 w-8 text-center justify-center text-orange-600 text-sm font-medium">
                  {item.queryStatusCounts?.ignored || 0}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // QueryCard component for individual query cards
  const QueryCard = ({ query, stageKey }) => (
    <div className="bg-white rounded-[10px] p-4 mb-4 cursor-pointer hover:shadow-md transition-shadow"
      >
      {/* Query Header */}
      <div className="flex items-start justify-between mb-3">
        <div    onClick={() => {
           setSelectedQuery(query);
           openSidebar('queryInfo', { query });
         }}  className="text-[16px] line-clamp-2 text-wrap font-semibold text-gray-800 hover:text-customGreen transition-colors">
          {query.title}
        </div>
        {stageKey === "PENDING" && (
          <div className="relative">
          <div
            className="cursor-pointer p-1 hover:bg-gray-200 rounded"
            onClick={(e) => {
              e.stopPropagation();
              toggleDropdown(query.id);
            }}
          >
            <CiMenuKebab className="text-lg" />
          </div>
          
          {activeDropdown === query.id && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg z-10">
              <div className="absolute -top-2 right-4 w-4 h-4 bg-white rotate-45"></div>
              <div className="py-2">
                {stageKey === "PENDING" && (
                  <>
                    <MenuItem
                      onClick={() => handleMenuClick(query, "resolve")}
                      iconAlt={<FiCheckCircle className="text-green-600" />}
                      label="Resolve"
                    />
                    <Divider />
                    <MenuItem
                      onClick={() => handleMenuClick(query, "ignore")}
                      iconAlt={<FiAlertCircle className="text-yellow-600" />}
                      label="Ignore Query"
                    />
                    <Divider />
                  </>
                )}
                <MenuItem
                  onClick={() => handleMenuClick(query, "edit")}
                  iconAlt={<FiEdit className="text-blue-600" />}
                  label="Edit"
                />
                <Divider />
                <MenuItem
                  onClick={() => handleMenuClick(query, "drop")}
                  iconAlt={<FiXCircle className="text-red-600" />}
                  label="Drop Property"
                />
              </div>
            </div>
          )}
        </div>
        )}
        
      </div>

      {/* Query Description */}
      <div className="text-[14px] text-wrap line-clamp-3 truncate font-normal text-gray-700 mb-3">
        {query.description}
      </div>

      {/* Query Given By */}
      <div className="text-[12px] text-[#505050] font-normal mb-3">
        Given by: <span className="font-medium">{query.givenBy?.name} ({query.givenBy?.role})</span>
      </div>

      {/* Query Date */}
      <div className="text-[12px] text-[#505050] font-normal mb-3">
        Given by date: <span className="font-medium">{query.createdTimestamp ? query.createdTimestamp : "N/A"}</span>
      </div>

      {/* Status-specific date */}
      {stageKey === "RESOLVED" ? (
        <div className="text-[14px] text-blue-500 font-normal mb-3">
          Solved Date: {query.statusTimestamp ? (query.statusTimestamp) : "N/A"}
        </div>
      ) : stageKey === "IGNORED" ? (
        <div className="text-[14px] text-blue-500 font-normal mb-3">
          Ignored Date: {query.statusTimestamp ? (query.statusTimestamp) : "N/A"}
        </div>
      ) : (
        <div className="text-[14px] text-blue-500 font-normal mb-3">
          Target Date: {query.targetDate || "N/A"}
        </div>
      )}

      {/* Query Badges */}
      <div className="flex gap-2">
        <span
          className={`px-3 py-1 flex items-center gap-2 rounded-full text-xs font-medium ${getPriorityBadgeColor(
            query.priority
          )}`}
        >
          {(periotyQueryEnum || []).find((p) => p.value === query.priority)?.icon || null}
          {(periotyQueryEnum || []).find((p) => p.value === query.priority)?.label || null}
        </span>
        <span className="px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-600">
          Category: {query.category}
        </span>
      </div>
    </div>
  );

  // Render stage column for Kanban layout
  const renderStageColumn = (stageKey, title , bgColor) => {
    const stage = stageData[stageKey];

    return (
      <div className="flex flex-col gap-4">
        <div className="text-[18px] font-medium">
          {title} ({stage?.count})
        </div>
        <div
          className={`bg- relative h-[calc(100vh-270px)] overflow-y-auto w-[370px] p-4 rounded-[10px] shadow ${bgColor}`}
          onScroll={(e) => handleScroll(e, stageKey)}
        >
          {stage.data.map((query) => (
            <QueryCard key={query.id} query={query} stageKey={stageKey} />
          ))}
          {stage.data.length === 0 && !stage.loading && (
            <div className="flex flex-col items-center justify-center h-full">
              <div className="text-gray-500 text-lg mt-4">
                No {title.toLowerCase()} queries found.
              </div>
            </div>
          )}
          {stage.loading && (
            <div className="flex justify-center py-4">
              <div className="text-gray-600">Loading...</div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="">
      <Header />
      <ToastContainer/>
      <div className="pt-28 px-6">
        <div>
          <CustomHeading title="Overall Query" />
        </div>
     
      
      {/* Add Query Header */}
      {/* <div className="flex items-center justify-between mb-5">
        <div className="text-[20px] font-medium">
          Queries ({statusCounts.total || 0})
        </div>
        <button
          onClick={() => openSidebar('addQuery')}
          className="bg-customGreen text-white px-4 py-2 rounded-[10px] disabled:opacity-50 hover:bg-green-600 transition-colors"
          disabled={loading}
        >
          Add Query
        </button>
      </div> */}

      {/* Kanban Columns */}
      <div className="h-screen overflow-x-auto mt-5 pb-4 custom-scrollbar pipeline flex gap-6">
        {renderPropertySelectionColumn()}
        {renderStageColumn("PENDING", "Pending" , "bg-blue-50")}
        {renderStageColumn("RESOLVED", "Resolved" , "bg-green-50")}
        {renderStageColumn("IGNORED", "Ignored" , "bg-orange-50")}
        {/* {renderStageColumn("DROPPED", "Dropped" , "bg-red-50")} */}
      </div>

      {/* Add Query Modal */}
      <CustomSidebar
        visible={isModalOpen}
        onHide={() => closeSidebar('addQuery')}
        width="600px"
        title="Add Query"
      >
        <div className="space-y-4">
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Category <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={queryCategories || []}
                value={(queryCategories || []).find((opt) => opt.value === formData.category) || null}
                onChange={(selected) => handleSelectChange("category", selected)}
                placeholder="Select Query Category"
              />
            </div>
          </div>
          {formData.category === "Advocate Analysis" && (
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Advocate Opinion <span className="text-red-500">*</span>
              </label>
              <div className="col-span-8">
                <CustomAdvocateList
                  advocateOpinions={advocateOpinions || []}
                  selectedOpinionId={formData.associatedLegalOpinion}
                  onChange={(selected) => handleSelectChange("associatedLegalOpinion", selected)}
                  placeholder="Select Advocate Opinion"
                />
              </div>
            </div>
          )}
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Title
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Enter query title"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Description
            </label>
            <div className="col-span-8">
              <textarea
                rows={4}
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Enter query description"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Priority
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={periotyQueryEnum || []}
                value={(periotyQueryEnum || []).find((opt) => opt.value === formData.priority) || null}
                onChange={(selected) => handleSelectChange("priority", selected)}
                placeholder="Select Query Priority"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Given By
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={users || []}
                value={(users || []).find((opt) => opt.value === formData.givenBy) || null}
                onChange={(selected) => handleSelectChange("givenBy", selected)}
                placeholder="Select User"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Target Date
            </label>
            <div className="col-span-8">
              <input
                type="date"
                name="targetDate"
                value={formData.targetDate}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
              />
            </div>
          </div>
          {formData.category !== "Advocate Analysis" && (
            <MediaUpload
              mediaType={"document"}
              files={formData.files || []}
              onChange={(files) => setFormData((prev) => ({ ...prev, files }))}
              accept="application/pdf,application/dwg,application/x-dwg,application/dxf,application/x-dxf"
              maxFiles={1}
              folderpath="AdvocateOpinion"
            />
          )}
          <button
            onClick={handleAddQuery}
            disabled={loading}
            className="w-full py-2 bg-customGreen text-white rounded-md disabled:opacity-50 hover:bg-green-600 transition-colors"
          >
            {loading ? "Submitting..." : "Add Query"}
          </button>
        </div>
      </CustomSidebar>

      {/* Resolve/Ignore/Drop Modal */}
      <CustomModel
        isOpen={isResolveModalOpen}
        isClose={() => {
          closeSidebar('resolveQuery');
          setResolveComment("");
          setSelectedQuery(null);
          setActionType(null);
        }}
        title={getActionTitle()}
        content={
          <div className="space-y-4">
            {selectedQuery && (
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <h3 className="font-medium text-gray-800 mb-2">Query Title</h3>
                <p className="text-gray-600 line-clamp-2 truncate text-wrap text-sm mb-2">{selectedQuery.title}</p>
                <p className="text-gray-500 line-clamp-3 truncate text-wrap text-xs">{selectedQuery.description}</p>
                <div className="flex items-center gap-4 mt-3 text-xs text-gray-500">
                  <span>Given By: {selectedQuery.givenBy?.name || "N/A"}</span>
                </div>
                {actionType === "resolve" && (
                  <div className="flex items-center gap-2 mt-2 text-xs">
                    <span>Resolved Date: {selectedQuery?.statusTimestamp ? formatToIndianDate(selectedQuery.statusTimestamp) : "N/A"}</span>
                  </div>
                )}
                <div className="flex gap-2 mt-2">
                  <span
                    className={`px-2 py-1 flex items-center gap-1 rounded-full text-xs font-medium ${getPriorityBadgeColor(
                      selectedQuery.priority
                    )}`}
                  >
                    {(periotyQueryEnum || []).find((p) => p.value === selectedQuery.priority)?.icon ||
                      null}
                    {(periotyQueryEnum || []).find((p) => p.value === selectedQuery.priority)?.label ||
                      null}
                  </span>
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-600">
                    Category: {selectedQuery.category}
                  </span>
                </div>
              </div>
            )}
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">
                {actionType === "resolve"
                  ? "Resolve Comment"
                  : actionType === "ignore"
                  ? "Ignore Comment"
                  : "Drop Comment"}
              </label>
              <textarea
                rows={4}
                value={resolveComment}
                onChange={(e) => setResolveComment(e.target.value)}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Type Comment"
              />
            </div>
            <div className="flex gap-3 pt-4">
              <button
                onClick={() => {
                  closeSidebar('resolveQuery');
                  setResolveComment("");
                  setSelectedQuery(null);
                  setActionType(null);
                }}
                className="flex-1 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                disabled={queryLoading}
                onClick={handleConfirmAction}
                className={`flex-1 py-2 text-white rounded-md transition-colors ${getActionButtonColor()}`}
              >
                {getActionButtonText()}
              </button>
            </div>
          </div>
        }
      />

      {/* Edit Query Modal */}
      <CustomSidebar
        visible={isEditModalOpen}
        onHide={() => {
          closeSidebar('editQuery');
          setEditFormData({
            title: "",
            description: "",
            category: null,
            givenBy: null,
            targetDate: "",
            priority: null,
            associatedLegalOpinion: null,
            files: [],
          });
        }}
        title="Edit Query"
        width="600px"
      >
        <div className="space-y-4">
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Category <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={queryCategories || []}
                value={editFormData.category}
                onChange={(selected) => handleEditSelectChange("category", selected)}
                placeholder="Select Query Category"
              />
            </div>
          </div>
          {editFormData.category?.value === "Advocate Analysis" && (
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Advocate Opinion <span className="text-red-500">*</span>
              </label>
              <div className="col-span-8">
                <CustomAdvocateList
                  advocateOpinions={advocateOpinions || []}
                  selectedOpinionId={editFormData.associatedLegalOpinion?.value}
                  onChange={(selected) =>
                    handleEditSelectChange("associatedLegalOpinion", selected)
                  }
                  placeholder="Select Advocate Opinion"
                />
              </div>
            </div>
          )}
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Title <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="title"
                value={editFormData.title}
                onChange={handleEditInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Enter query title"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Description <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <textarea
                rows={4}
                name="description"
                value={editFormData.description}
                onChange={handleEditInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Enter query description"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Priority <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={periotyQueryEnum || []}
                value={editFormData.priority}
                onChange={(selected) => handleEditSelectChange("priority", selected)}
                placeholder="Select Query Priority"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Given By <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={users || []}
                value={editFormData.givenBy}
                onChange={(selected) => handleEditSelectChange("givenBy", selected)}
                placeholder="Select User"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Target Date <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <input
                type="date"
                name="targetDate"
                value={editFormData.targetDate}
                onChange={handleEditInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
              />
            </div>
          </div>
          {editFormData.category?.value !== "Advocate Analysis" && (
            <MediaUpload
              mediaType={"document"}
              files={editFormData.files}
              onChange={(files) => setEditFormData((prev) => ({ ...prev, files }))}
              accept="application/pdf,application/dwg,application/x-dwg,application/dxf,application/x-dxf"
              maxFiles={1}
              folderpath="AdvocateOpinion"
            />
          )}
          <button
            onClick={handleUpdateQuery}
            disabled={loading}
            className="w-full py-2 bg-customGreen text-white rounded-md disabled:opacity-50 hover:bg-green-600 transition-colors"
          >
            {loading ? "Updating..." : "Update Query"}
          </button>
        </div>
      </CustomSidebar>

      {/* Query Info Page Modal */}
      <CustomSidebar
        visible={isQueryInfoOpen}
        onHide={() => {
          closeSidebar('queryInfo');
          setSelectedQuery(null);
        }}
        title={`Query Details - ${selectedQuery?.title}`}
        width="1300px"
      >
        <QueriesInfoPage
          propertyId={selectedPropertyId}
          handleMenuClick={handleMenuClick}
          queryData={selectedQuery}
        />
      </CustomSidebar>
    </div>
     </div>
  );
};

export default ProcurementQueryPage;